import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import formData from "./formData"; 

const ChuanPiaoApi = createApi({
    reducerPath: 'ChuanPiaoApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/x/cp'        
    }),
    tagTypes: ['firm', 'user'], 
    endpoints: (build) => ({ 
        // 新增企业
        firmAdd: build.mutation({
            query: (user) => ({              
                url: '/firmAdd',
                method: 'post',
                body: formData(user) 
            }),                     
            invalidatesTags: ['firm'],
        }),         
        // 企业列表
        firmList: build.query({
            query: (user) => ({              
                url: '/firmList',
                method: 'post',
                body: formData(user) 
            }),                     
            providesTags: ['firm'],
        }),         
        // 修改企业
        firmUpdate: build.query({
            query: (user) => ({              
                url: '/firmUpdate',
                method: 'post',
                body: formData(user) 
            }),                     
            providesTags: ['firm'],
        }),         
        // 删除企业
        firmDel: build.mutation({
            query: (user) => ({              
                url: '/firmDel',
                method: 'post',
                body: formData(user) 
            }),                     
            invalidatesTags: ['firm'],
        }),         
        // 修改保存企业 
        firmUpdateSave: build.mutation({
            query: (user) => ({              
                url: '/firmUpdateSave',
                method: 'post',
                body: formData(user) 
            }),                     
            invalidatesTags: ['firm'],
        }),         
        // 新增操作员
        userAdd: build.mutation({
            query: (user) => ({              
                url: '/userAdd',
                method: 'post',
                body: formData(user) 
            }),                     
            invalidatesTags: ['user'],
        }),         
        // 操作员列表
        userList: build.query({
            query: (user) => ({              
                url: '/userList',
                method: 'post',
                body: formData(user) 
            }),                     
            providesTags: ['user'],
        }),         
        // 修改操作员
        userUpdate: build.query({
            query: (user) => ({              
                url: '/userUpdate',
                method: 'post',
                body: formData(user) 
            }),                     
            providesTags: ['user'],
        }),         
        // 删除操作员
        userDel: build.mutation({
            query: (user) => ({              
                url: '/userDel',
                method: 'post',
                body: formData(user) 
            }),                     
            invalidatesTags: ['user'],
        }),         
        // 修改保存操作员 
        userUpdateSave: build.mutation({
            query: (user) => ({              
                url: '/userUpdateSave',
                method: 'post',
                body: formData(user) 
            }),                     
            invalidatesTags: ['user'],
        }),         
        // 新增评价模板
        templateAdd: build.mutation({
            query: (template) => ({              
                url: '/templateAdd',
                method: 'post',
                body: formData(template) 
            }),                     
            invalidatesTags: ['template'],
        }),         
        // 评价模板列表
        templateList: build.query({
            query: (template) => ({              
                url: '/templateList',
                method: 'post',
                body: formData(template) 
            }),                     
            providesTags: ['template'],
        }),         
        // 修改评价模板
        templateUpdate: build.query({
            query: (template) => ({              
                url: '/templateUpdate',
                method: 'post',
                body: formData(template) 
            }),                     
            providesTags: ['template'],
        }),         
        // 删除评价模板
        templateDel: build.mutation({
            query: (template) => ({              
                url: '/templateDel',
                method: 'post',
                body: formData(template) 
            }),                     
            invalidatesTags: ['template'],
        }),         
        // 修改保存评价模板 
        templateUpdateSave: build.mutation({
            query: (template) => ({              
                url: '/templateUpdateSave',
                method: 'post',
                body: formData(template) 
            }),                     
            invalidatesTags: ['template'],
        }),         
        // 新增评价项目
        itemAdd: build.mutation({
            query: (item) => ({              
                url: '/itemAdd',
                method: 'post',
                body: formData(item) 
            }),                     
            invalidatesTags: ['item'],
        }),         
        // 评价项目列表
        itemList: build.query({
            query: (item) => ({              
                url: '/itemList',
                method: 'post',
                body: formData(item) 
            }),                     
            providesTags: ['item'],
        }),         
        // 修改评价项目
        itemUpdate: build.query({
            query: (item) => ({              
                url: '/itemUpdate',
                method: 'post',
                body: formData(item) 
            }),                     
            providesTags: ['item'],
        }),         
        // 删除评价项目
        itemDel: build.mutation({
            query: (item) => ({              
                url: '/itemDel',
                method: 'post',
                body: formData(item) 
            }),                     
            invalidatesTags: ['item'],
        }),         
        // 修改保存评价项目 
        itemUpdateSave: build.mutation({
            query: (item) => ({              
                url: '/itemUpdateSave',
                method: 'post',
                body: formData(item) 
            }),                     
            invalidatesTags: ['item'],
        }),         
           
    })
});

export const {   
    useFirmAddMutation,
    useFirmListQuery,
    useFirmUpdateQuery,
    useFirmDelMutation,
    useFirmUpdateSaveMutation,
    useUserAddMutation,
    useUserListQuery,
    useUserUpdateQuery,
    useUserDelMutation,
    useUserUpdateSaveMutation,
    useTemplateAddMutation,
    useTemplateListQuery,
    useTemplateUpdateQuery,
    useTemplateDelMutation,
    useTemplateUpdateSaveMutation,
    useItemAddMutation,
    useItemListQuery,
    useItemUpdateQuery,
    useItemDelMutation,
    useItemUpdateSaveMutation,
} = ChuanPiaoApi;

export default ChuanPiaoApi;